import { Row, Column } from 'gatsby-theme-carbon/src/components/Grid';
import { withPrefix } from "gatsby";
import ToolkitRequirement from "../../../../src/components/rms_resources/requirements";
import ToolkitReference from "../../../../src/components/rms_resources/references";
import ToolkitTechnique from "../../../../src/components/rms_resources/techniques";
import ToolkitTopic from "../../../../src/components/rms_resources/topics";
import img1 from "../../../../src/visuals/design/L2_content_text_meaning_3_eg.png";
import img2 from "../../../../src/visuals/design/L2_content_5_2_do.png";
import img3 from "../../../../src/visuals/design/L2_content_text_meaning_4_dont.png";
import "../../../../src/pages/toolkit/topics.scss";
import * as React from 'react';
export default {
  Row,
  Column,
  withPrefix,
  ToolkitRequirement,
  ToolkitReference,
  ToolkitTechnique,
  ToolkitTopic,
  img1,
  img2,
  img3,
  React
};